import { useState, useEffect } from "react";
import axios from "axios";
import { APP_META_TRAVEL_ADS_API_ENDPOINT } from "constants/api_urls";
import { getUserToken } from "utils/functions/userToken";

/**
 * Hook to fetch the list of eligible hotels for Meta Hotel Ads campaigns.
 * Calls GET /api/meta-ads/meta-hotels/{accountId}
 *
 * @param {string|number} accountId - The account ID
 * @returns {{ hotelOptions: Array<{hotel_id: string, hotel_name: string}>, isLoading: boolean }}
 */
const useMetaHotels = (accountId) => {
  const [hotelOptions, setHotelOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!accountId) return;
    setIsLoading(true);
    const token = getUserToken();
    axios
      .get(`${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/meta-hotels/${accountId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setHotelOptions(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => {
        setHotelOptions([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [accountId]);

  return { hotelOptions, isLoading };
};

export default useMetaHotels;
